import { Component, input, ChangeDetectionStrategy } from "@angular/core";
import { MenuComponent } from "common/menu/menu.component";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-right-navigation-rail",
	templateUrl: "./right-navigation-rail.component.html",
	styleUrls: ["./right-navigation-rail.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MenuComponent, NgClass, TranslateModule],
})
export class RightNavigationRailComponent {
	readonly menuItems = input<MenuItem[]>([]);

	readonly buttons = input<Button[]>([]);
}
